import React from 'react';
import { useLang } from '../context/LangContext';

const WA_URL = 'https://wa.me/9647703705004';
const EMAIL  = 'abd94057@gmail.com';

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="#25D366" style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.118 1.535 5.845L.057 23.571a.75.75 0 0 0 .921.921l5.738-1.476A11.944 11.944 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.943 0-3.753-.524-5.306-1.437l-.38-.224-3.938 1.013 1.037-3.82-.247-.393A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
    </svg>
  );
}

export default function Footer() {
  const { t, dir } = useLang();
  const F = t.footer;

  return (
    <footer style={{
      textAlign: 'center',
      padding: '28px 24px',
      color: 'rgba(255,255,255,0.42)',
      fontSize: '13px',
      borderTop: '1px solid rgba(255,255,255,0.07)',
      marginTop: '60px',
      direction: dir,
      lineHeight: 1.8,
    }}>
      <p style={{ color: 'rgba(255,255,255,0.55)', marginBottom: '4px' }}>{F.tagline}</p>
      <p>{F.rights} © {new Date().getFullYear()}</p>

      <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
        <a
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex', alignItems: 'center',
            color: '#25D366', textDecoration: 'none', fontSize: '13px',
            border: '1px solid rgba(37,211,102,0.35)', borderRadius: '20px',
            padding: '6px 14px', transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(37,211,102,0.1)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          <WhatsAppIcon />
          Feedback or questions? Contact us on WhatsApp
        </a>
        <a
          href={`mailto:${EMAIL}`}
          style={{
            color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: '12px',
          }}
        >
          {EMAIL}
        </a>
      </div>
    </footer>
  );
}
